/**
 * ModuERP v2.0 — lazy-loaded core modules (code splitting).
 *
 * Everything here is kept out of the initial bundle. The Designer family is the
 * expensive half: it drags Monaco (editor core + LavkaLang language services),
 * so an operator who never opens the Designer must not pay for it.
 */
import React, { lazy } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export const ConnectionsModule = lazy(() =>
  import('@/app/core/connections/ConnectionsModule').then((m) => ({ default: m.default }))
);
export const MarketplaceModule = lazy(() =>
  import('@/app/core/marketplace/MarketplaceModule').then((m) => ({ default: m.MarketplaceModule }))
);

// ── Designer family — the Monaco carriers ──────────────────────────────
export const DesignerHome = lazy(() =>
  import('@/designer').then((m) => ({ default: m.DesignerHome }))
);
export const ConfigurationTreePage = lazy(() =>
  import('@/app/pages/ConfigurationTreePage').then((m) => ({ default: m.ConfigurationTreePage }))
);
export const SchemaDesignerPage = lazy(() =>
  import('@/app/pages/SchemaDesignerPage').then((m) => ({ default: m.SchemaDesignerPage }))
);
export const EditorPlayground = lazy(() => import('@/designer/EditorPlayground'));
export const PrintTemplateEditorPage = lazy(() => import('@/app/pages/PrintTemplateEditorPage'));

// ── Other heavy, rarely-first-visited screens ─────────────────────────
export const DashboardPage = lazy(() =>
  import('@/app/pages/DashboardPage').then((m) => ({ default: m.DashboardPage }))
);
export const ThemeStudioPage = lazy(() => import('@/app/pages/ThemeStudioPage'));
export const FormInheritanceLabPage = lazy(() =>
  import('@/dev/form-lab/FormInheritanceLabPage').then((m) => ({
    default: m.FormInheritanceLabPage,
  }))
);

/**
 * Suspense fallback for lazy routes.
 *
 * The spinner fades in only after 300ms, so a chunk that arrives from cache
 * shows nothing at all instead of a flash. Pure CSS — no timer to clean up.
 */
export const RouteFallback: React.FC = () => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      p: 4,
      opacity: 0,
      animation: 'routeFallbackIn 120ms linear 300ms forwards',
      '@keyframes routeFallbackIn': { to: { opacity: 1 } },
    }}
  >
    <CircularProgress />
  </Box>
);
